<template>
  <inline-svg 
    class="svg-icon"
    @click="$emit('click')"
    :src="require(`@/assets/svg/${name}.svg`)" 
    :title="title"
    :aria-label="title"
  />
</template>
<script>
export default {
  name: 'svg-icon',
  props: {
    name: {
      type: String,
      required: true
    },
    title: {
      type: String
    }
  },
}
</script>